export function tableDataPageItems<T>(items: T[], pageSize: number, pageCurrent: number): T[] {
    const startingIndex = pageSize * (pageCurrent - 1);
    const paginatedItems = items.length > pageSize ? items.slice(startingIndex, startingIndex + pageSize) : items;
    return paginatedItems;
}
